/**
 * Maintenance: all authenticated members can view and create.
 * Update/archive: Team Leader or Maintenance bureau (bureau_id 4) only (admins are not elevated).
 * Workflow fields: Team Leader or Maintenance bureau only.
 */

export function isMaintenanceBureauMember(user) {
  return user?.bureau_id === 4;
}

export function isTeamLeaderUser(user) {
  return Boolean(user?.is_team_leader) || user?.management_id === 1;
}

export function canManageMaintenanceWorkflow(user) {
  return isTeamLeaderUser(user) || isMaintenanceBureauMember(user);
}

export function canModifyMaintenanceRequest(user, maintenance) {
  if (!user || !maintenance) return false;
  return (
    isTeamLeaderUser(user) ||
    isMaintenanceBureauMember(user)
  );
}

/** User may archive maintenance request (authorized; not already archived). */
export function canArchiveMaintenanceRequest(user, maintenance) {
  if (!canModifyMaintenanceRequest(user, maintenance)) return false;
  return !maintenance?.archived_at;
}
